module.exports = __webpack_public_path__ + "static/baltimore-4cd5af447bfd07ef7028f58054ae2cd6.png";